import React, { useContext, useEffect, useState } from "react";

import { Form, Formik, FormikProps } from "formik";

import DataFetch from "../../../../../../../images/OpenIcon.svg";

import { TextField } from "@mui/material";
import Close from "../../../../../../../images/Close.svg";
import {
  mrfToPoFormData,
  rfqPoFormData,
} from "../../../../../../../utils/formTypes";
import { AppContext } from "../../../../../../../context/context";
import { Operation } from "../../../../../../../utils/Enum.types";
import { Title } from "../../../../../../../stories/Title/Title";
import { LabelProps } from "../../../../../../../utils/types";
import { Label } from "../../../../../../../stories/Label/Label";
import TextArea from "../../../../../../../stories/TextArea/TextArea";
import {
  CustomModal,
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
  toStandardDate,
} from "../../../../../../../utils/UtilFunctions";
import InputNumber from "../../../../../../common/Input/InputNumber";
import RFQSelect from "./RFQSelect";
import { payloadTypes } from "../../../../../../../context/reducer";
import InputHoc from "../../../../../../common/Input/Index";
import { Button } from "../../../../../../../stories/Button/Button";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../../styles/AutocompleteStyles";
import { ViewModalStyles } from "../../../../../../../styles/CustomModalStyles";
import RfqItems from "../RfqItems";
import { rfqPoAddItem } from "../../../../../../../utils/validationSchema";
import { Keys } from "../../../../../../../utils/Enum.keys";
import { AtsMrfMstEdge, AtsMrfTrn } from "../../../material/queries/types";
import MRFSelect from "./MRFSelect";
import useLabels from "../../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../../json/useFormJson";
interface formDataProp {
  formData: mrfToPoFormData;
  setFormData: React.Dispatch<React.SetStateAction<mrfToPoFormData>>;
}

interface rfqAndItemProp {
  editRfq: AtsMrfMstEdge | null;
  editItm: AtsMrfTrn | null;
}
interface Props {
  operation: Operation;
  hanldeItemRow: (formData: mrfToPoFormData) => void;
  itemsCount: number;
  setModal: (value: React.SetStateAction<boolean>) => void;
  formDataState: formDataProp;
  editState: rfqAndItemProp;
}

const AddMrfModal = ({
  operation,
  hanldeItemRow,
  itemsCount,
  setModal,
  formDataState,
  editState,
}: Props) => {
  const initialValues: mrfToPoFormData = {
    mrfNo: "",
    mrfDate: "",
    slNo: "",
    udfItemDesc: "",
    itemUom: "",
    itemQty: "",
    itemRate: "",
    itemOther: "",
    itemTaxable: "",
    itemTax: "",
    itemInstChrg: "",
    itemDelvChrg: "",
    itemDeliveryDate: "",
    itemValue: "",
    netTotal: 0,
    itemID: 0,
    mrfTrnID: 0,
    mrfID: 0,
    remarks: "",
    itemDeliverySts: "",
  };

  const { dispatch } = useContext(AppContext);
  const { formData, setFormData } = formDataState;
  const [selectedMrf, setSelectedMrf] = useState<AtsMrfMstEdge | null>(null);
  const [selectedItm, setSelectedItm] = useState<AtsMrfTrn | null>(null);
const {MRFPOAdd}=useFormJson();
  const [itemDescription, setItemDescription] = useState(false);

  const { editItm, editRfq } = editState;

  const selectMrf = (mrf: AtsMrfMstEdge | null) => {
    if (mrf) {
      setSelectedMrf(mrf as AtsMrfMstEdge);
      dispatch({
        type: payloadTypes.SET_MRF_ID,
        payload: {
          mrfId: (mrf as AtsMrfMstEdge).node.id,
        },
      });
      setFormData({
        ...formData,
        mrfID: (mrf as AtsMrfMstEdge).node.id,
        mrfDate: toStandardDate(mrf.node.mrfDate),
        mrfNo: mrf.node.mrfNo,
      });
    } else {
      setSelectedMrf(null);
      dispatch({
        type: payloadTypes.SET_RFQ_ID,
        payload: {
          rfqId: 0,
        },
      });
      setFormData(initialValues);
    }
  };

  const handleClear = () => {
    dispatch({
      type: payloadTypes.SET_MRF_ID,
      payload: {
        mrfId: 0,
      },
    });
    setFormData(initialValues);
    setSelectedItm(null);
    setSelectedMrf(null);
  };

  const selectItem = (rfq: AtsMrfTrn | null) => {
    if (rfq) {
      setSelectedItm(rfq as AtsMrfTrn);
      const other =
        rfq.approxDlvryRate + rfq.approxInstRate + rfq.approxOtherRate;

      const taxableRate =
        (Number(rfq.acceptQty) * Number(rfq.acceptRate) + other) *
        (rfq.tax / 100);
      setFormData({
        ...formData,
        udfItemDesc: rfq.udfItemDesc,
        itemUom: rfq.uom,
        itemQty: rfq.acceptQty.toString(),
        itemRate: rfq.acceptRate.toString(),
        itemOther: other.toString(),
        itemTaxable: taxableRate.toString(),
        itemTax: rfq.tax.toString(),
        itemValue: (
          Number(rfq.acceptQty) * Number(rfq.acceptRate) +
          other
        ).toString(),
        itemInstChrg: rfq.approxInstRate.toString(),
        itemDelvChrg: rfq.approxDlvryRate.toString(),
        itemDeliverySts: "0",
        itemID: rfq.item.id,
        rfqTrnID: rfq.id,
        rfqTrnSlNo: rfq.slNo,
        netTotal:
          Number(rfq.acceptQty) * Number(rfq.acceptRate) + other + taxableRate,
      });
    } else {
      setSelectedItm(null);
      setFormData({
        ...formData,
        ...initialValues,
      });
    }
  };
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<mrfToPoFormData>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const handleForm = () => {
    hanldeItemRow(formData);
    setSelectedItm(null);
    setSelectedMrf(null);
  };
  const handleSubmit = () => {
    setModal(false);
    hanldeItemRow(formData);
    setSelectedItm(null);
    setSelectedMrf(null);
  };
  useEffect(() => {
    if (operation === Operation.UPDATE) {
      setSelectedMrf(editRfq);
      setSelectedItm(editItm);
    }
  }, [operation, editRfq, editItm]);

  const {itemLabel}=useLabels();

  return (
    <>
      <div className="material-item-add">
        <div className="material-item-add__title">
          <Title>Add MRF</Title>
          <img src={Close} alt="" onClick={() => setModal(false)} />
        </div>

        <Formik
          initialValues={formData}
          validationSchema={rfqPoAddItem}
          onSubmit={handleForm}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className="material-item-add__form">
                <div className="material-item-add__form--details row g-0">
                  <div className="material-item-add__form--details--left col">
                    {MRFPOAdd.AddItem.leftForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  disabled={field.disabled}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  onKeyDown={handleFormEvent}
                                  className={field.className}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "mrfs") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <div className="material-item-add__form--details--flex">
                                  <MRFSelect
                                    onChange={(newValue) => {
                                      selectMrf(newValue);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === Keys.ENTER) {
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    autofocus={true}
                                    value={selectedMrf}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        } else if (field.dataType === "items") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{itemLabel} Description</Label>
                                <div className="material-item-add__form--details--flex">
                                  <FormAutocomplete
                                    className={formClasses.inputRoot}
                                    options={
                                      selectedMrf
                                        ? selectedMrf.node.rfqPendingItems
                                        : []
                                    }
                                    onKeyDown={(e: React.KeyboardEvent) => {
                                      if (e.key === Keys.ENTER) {
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    getOptionLabel={(option: any) =>
                                      (option as AtsMrfTrn).udfItemDesc
                                    }
                                    value={selectedItm}
                                    onChange={(e, newValue) => {
                                      selectItem(newValue as AtsMrfTrn | null);
                                    }}
                                    openOnFocus
                                    forcePopupIcon
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        className={formClasses.formControlRoot}
                                      />
                                    )}
                                  />

                                  <img
                                    src={DataFetch}
                                    alt=""
                                    className="data-fetch-icon"
                                    onClick={() =>
                                      setItemDescription(!itemDescription)
                                    }
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                                disabled={field.disabled}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="material-item-add__form--details--right col">
                    {MRFPOAdd.AddItem.rightForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as React.Dispatch<
                                        React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      >
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  className={field.className}
                                  onKeyDown={handleFormEvent}
                                  disabled={field.disabled}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col">
                    <Button
                      mode={
                        operation === Operation.CREATE
                          ? "save-continue"
                          : "save"
                      }
                      type="submit"
                    >
                      {operation === Operation.CREATE ? (
                        <>&nbsp;({itemsCount})</>
                      ) : null}
                    </Button>
                    <Button mode="clear" onClick={handleClear} type="button" />
                    <Button
                      mode="cancel"
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_MRF_ID,
                          payload: {
                            mrfId: 0,
                          },
                        });
                        setFormData(initialValues);
                        setModal(false);
                      }}
                      type="button"
                    />
                  </div>
                  {operation === Operation.CREATE ? (
                    <div className="col flex-end">
                      <Button
                        mode="save"
                        onClick={() => {
                          handleSubmit();
                        }}
                        type="button"
                      />
                    </div>
                  ) : null}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <CustomModal
        isOpen={itemDescription}
        onRequestClose={() => setItemDescription(false)}
        contentComponent={<RfqItems setModalFlag={setItemDescription} />}
        style={ViewModalStyles}
      />
    </>
  );
};

export default AddMrfModal;
